module.exports = {"130130100":"无极镇","130130101":"七汲镇","130130102":"张段固镇","130130103":"北苏镇","130130104":"郭庄镇","130130105":"大陈镇","130130200":"高头回族乡","130130201":"郝庄乡","130130202":"东侯坊乡","130130203":"里城道乡","130130204":"南流乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130130.json
// module id = 72
// module chunks = 0